define('uikit/modules/accordion',['require','exports','module','underscore','marionette','backbone','../channel','../mixins/component.mixin','templates','../definitions/modules/accordion'],function(require, exports, module){
  var _              = require('underscore');
  var Mn             = require('marionette');
  var Backbone       = require('backbone');
  var channel        = require('../channel');
  var ComponentMixin = require('../mixins/component.mixin');
  var Templates      = require('templates');
  require('../definitions/modules/accordion');

  var Accordion = Mn.ItemView.extend(ComponentMixin).extend({

    className: 'ui accordion',

    template: Templates.App['accordion'],

    ui: {
      contents: '.content'
    },

    options: {
      inverted        : false,
      styled          : false,
      exclusive       : true,
      animateChildren : true,
      collapsible     : true,
      fluid           : false
    },

    forceUpdate: { exclusive: true, animateChildren: true, collapsible: true },

    events: {
      'keydown > .title' : 'handleKeydownToggle'
    },

    initialize: function() {
      ComponentMixin.initialize.apply(this, arguments);
      if (!this.collection) {
        this.collection = new Backbone.Collection();
      }
    },

    updateAttributes: function() {
      this
          .addClass('styled', this.getBoolOption('styled'))
          .addClass('fluid', this.getBoolOption('fluid'))
          .addClass('inverted', this.getBoolOption('inverted'))
    },

    onFirstRender: function() {
      if (this.collection) {
        this.listenTo(this.collection, 'add remove sort reset', this._requestRender);
      }
    },

    onRender: function() {
      _.each(this.ui.contents, function(content, index) {
        var model = this.collection.at(index);

        if (model.get('content')) {
          $(content).append(model.get('content'));
        } else if (model.get('view')) {
          var view = model.get('view')
          $(content).append(view.el);
          if (!view._isRendered) {
            view.render();
          }
        }
      }, this);

      this.$el
          .accordion(_.extend({}, this.options, {
            onChange: _.bind(this._onChange, this),
            onClose: _.bind(this._onClose, this),
            onOpen: _.bind(this.onOpen, this)
          }));

      this.$el.find('> .title').attr('tabindex', 0);

      if (this.collection) {
        this.collection.each(function(model, index) {
          if (model.get('open') === true) {
            this.$el.accordion('open', index);
          }
        }, this);
      }
    },

    add: function(text, view, open) {
      this.collection.add({
        text    : text,
        view    : view,
        icon    : 'dropdown',
        open    : !!open
      });
      return this;
    },

    open: function(index) {
      this.$el.accordion('open', index)
      return this;
    },

    close: function(index) {
      this.$el.accordion('close', index)
      return this;
    },

    toggle: function(index) {
      this.$el.accordion('toggle', index);
      return this;
    },

    _onChange: function() {
    },

    _onClose: function() {
    },

    onOpen: function() {
    },

    // Handle the keydown event on an accordion item's title to toggle
    handleKeydownToggle: function(ev) {
      // Toggle on the Enter key
      if (ev.keyCode == 13) {
        // Retrieve the stored index from the target element
        var index = parseInt(ev.currentTarget.dataset.index);

        this.toggle(index);
      }
    }

  });

  channel.reply('accordion', function() {
    return Accordion;
  });

  module.exports = Accordion;
});
